'use client';

import { DeviceSwitcher } from '../../components/device-switcher.component';
import { useHeaderCurrentUserFacade } from '../../hooks/use-header-current-user.facade';
import { useLogoutFacade } from '../../hooks/use-logout.facade';
import { CareerMotivationButtonWithModalContainer } from './career-motivation/career-motivation-button-with-modal.container';
import { MainDesktopContent } from './desktop/main-desktop-content.component';
import { MainMobileContent } from './mobile/main-mobile-content.component';
import { MobileNavigation } from './mobile/mobile-navigation.component';
import { useGetCurrentPathFacade } from './use-get-current-path.facade';

type Props = {
  isShowMobileNavigation?: boolean;
};

// TODO:
// useHeaderCurrentUserFacade内に記載している事項が解消されたらCareerMotivationButtonWithModalContainerをdynamic importする
export const MainContentContainer = ({ isShowMobileNavigation }: Props) => {
  const {
    isTargetUser,
    isFreelanceUser,
    userName,
    unreadMessageCount,
    inputProgress,
    unreadCount,
    userCareerMotivation,
    unreadNotificationsJobDescriptionLikeCount,
  } = useHeaderCurrentUserFacade();
  const { handleLogout } = useLogoutFacade();
  const { pathname, activePage } = useGetCurrentPathFacade();
  return (
    <DeviceSwitcher
      desktop={
        <MainDesktopContent
          isFreelanceUser={isFreelanceUser}
          isTargetUser={isTargetUser}
          pathname={pathname}
          profileCompletionProgress={inputProgress}
          unreadCount={unreadCount}
          unreadMessageCount={unreadMessageCount}
          userName={userName}
          onLogout={handleLogout}
        >
          <CareerMotivationButtonWithModalContainer
            motivationId={userCareerMotivation}
          />
        </MainDesktopContent>
      }
      mobile={
        <>
          <MainMobileContent
            isFreelanceUser={isFreelanceUser}
            isTargetUser={isTargetUser}
            pathname={pathname}
            profileCompletionProgress={inputProgress}
            unreadCount={unreadCount}
            unreadMessageCount={unreadMessageCount}
            onLogout={handleLogout}
          >
            <CareerMotivationButtonWithModalContainer
              motivationId={userCareerMotivation}
            />
          </MainMobileContent>
          {isShowMobileNavigation && (
            <MobileNavigation
              activePage={activePage}
              unreadMessageCount={unreadMessageCount}
              unreadNotificationsJobDescriptionLikeCount={
                unreadNotificationsJobDescriptionLikeCount
              }
            />
          )}
        </>
      }
    />
  );
};
